// lib/mailDeLaUrl.js
// El mail del comprador no puede quedar en la URL cuando cargan el pixel de Meta, el tag de
// Google Ads y Clarity: los tres se llevan la URL entera (PageView, page_location, la
// grabación). Meta y Google lo prohíben en sus condiciones, y es un dato personal que sale a
// terceros (GDPR). Medido el 22-sep-2026: unas 790 visitas por semana con un mail en la URL.
//
// El mail viene en la URL a propósito, para precargarlo: links de campañas y de los mails
// (?email=, ?m=), "completá tu colección", el paso al checkout. Los links de los mails ya
// enviados no se pueden cambiar, así que el arreglo va en la página que los recibe:
//
//  1. SCRIPT_SACAR_MAIL va crudo al principio del <head> (app/[locale]/layout.js). Corre antes
//     que todo lo de terceros (el pixel va afterInteractive, Clarity lazyOnload, Ads y GA4
//     después de hidratar): guarda el mail en el sessionStorage de la pestaña, atado a ESA
//     página, y lo saca de la URL con history.replaceState. Next arma su router con la URL que
//     encuentra al hidratar, así que useSearchParams() ya la ve limpia.
//  2. Los componentes leen el mail con mailDeLaUrl(searchParams): el de la URL si sigue ahí, o
//     el que se guardó para esta página.
//
// Todos los que arman un link con el mail navegan con carga completa (window.location.href o
// un <a> común), así que el script del destino lo vuelve a sacar. Una navegación sin recarga
// (router.push, <Link>) NO pasa por el script: no armar así un link con el mail.
//
// Si el sessionStorage no anda, el script no toca la URL: mejor el mail a la vista que una
// página que pierde el dato y cobra sin el descuento de lo que ya tenía.
//
// `?m=` también lo usa el Círculo de Quintas para el código de un mandala: solo se saca un
// valor con "@".
//
// El script es ES5 a mano por lo mismo que lib/compat/aviso.js: corre antes y afuera del
// bundle. Hay un test que lo verifica.

export const CLAVE_MAIL = "bcm_mail_url";

/** La página a la que queda atado el mail: sin el idioma, para que /es/x y /x sean la misma. */
export function rutaDelMail(pathname) {
  return String(pathname || "").replace(/^\/[a-z]{2}(?=\/|$)/, "").replace(/\/+$/, "") || "/";
}

export const SCRIPT_SACAR_MAIL =
  "(function(){try{" +
  "var w=window,l=w.location,s=l.search;" +
  'if(!s||(s.indexOf("@")<0&&s.indexOf("%40")<0))return;' +
  'var partes=s.slice(1).split("&"),quedan=[],mail="",i,p,j,k,v;' +
  "for(i=0;i<partes.length;i++){p=partes[i];j=p.indexOf(\"=\");" +
  'try{k=decodeURIComponent((j<0?p:p.slice(0,j)).replace(/\\+/g," "));' +
  'v=j<0?"":decodeURIComponent(p.slice(j+1).replace(/\\+/g," "))}catch(e){quedan.push(p);continue}' +
  'if((k==="email"||k==="m")&&v.indexOf("@")>0){if(!mail)mail=v.replace(/^\\s+|\\s+$/g,"")}else quedan.push(p)}' +
  "if(!mail)return;" +
  'var ruta=l.pathname.replace(/^\\/[a-z]{2}(?=\\/|$)/,"").replace(/\\/+$/,"")||"/",ss=w.sessionStorage,m;' +
  "try{m=JSON.parse(ss.getItem(" + JSON.stringify(CLAVE_MAIL) + "))}catch(e){}" +
  'if(!m||typeof m!=="object")m={};' +
  "m[ruta]=mail;ss.setItem(" + JSON.stringify(CLAVE_MAIL) + ",JSON.stringify(m));" +
  "if((JSON.parse(ss.getItem(" + JSON.stringify(CLAVE_MAIL) + "))||{})[ruta]!==mail)return;" +
  'w.history.replaceState(w.history.state,"",l.pathname+(quedan.length?"?"+quedan.join("&"):"")+l.hash)' +
  "}catch(e){}})();";

/** El mail que el script del <head> guardó para la página actual, o "". */
export function mailGuardado() {
  if (typeof window === "undefined") return "";
  try {
    const guardados = JSON.parse(window.sessionStorage.getItem(CLAVE_MAIL) || "{}") || {};
    const mail = guardados[rutaDelMail(window.location.pathname)];
    return typeof mail === "string" ? mail : "";
  } catch {
    return "";
  }
}

/**
 * El mail con que llegó el visitante: el de la URL si sigue ahí (el script no corrió o no pudo
 * guardar), o el que se guardó para esta página. En el server da "" si la URL no lo trae.
 */
export function mailDeLaUrl(searchParams, params = ["email", "m"]) {
  for (const clave of params) {
    const valor = (searchParams?.get(clave) || "").trim();
    if (valor) return valor;
  }
  return mailGuardado().trim();
}
